module.exports = __webpack_public_path__ + "p7_img2.jpg?8d8902662889534259db951b92b8b5ac";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p7/p7_img2.jpg
// module id = 127
// module chunks = 0